import { Component, computed } from '@angular/core';
import { getFieldValue } from '@core/jss-utils';
import {
  getOrderOverviewFields,
  getYearlyCostsLabel,
} from '@innogy/become-a-customer/shared';
import { CommonModule } from '@angular/common';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { SvgSkeletonLoaderComponent } from '@legacy/common-ui-shared';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackLinkDirective } from '@analytics/events';
import { UtilsModule } from '@innogy/utils-deprecated';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';

import { BaseOrderOverviewComponent } from '../base-order-overview/base-order-overview.component';
import { OfferOverviewChangeOfferComponent } from '../order-overview-shared/offer-overview-change-offer/offer-overview-change-offer.component';
import { OrderOverviewConsumptionComponent } from '../order-overview-shared/order-overview-consumption/order-overview-consumption.component';
import { OrderOverviewStickerComponent } from './order-overview-sticker/order-overview-sticker.component';
import { OrderOverviewCostComponent } from '../order-overview-shared/order-overview-cost/order-overview-cost.component';
import { OrderOverviewBudgetBillComponent } from '../order-overview-shared/order-overview-budget-bill/order-overview-budget-bill.component';
@Component({
  selector: 'sme-order-overview',
  templateUrl: './order-overview-sme.component.html',
  styleUrls: ['./order-overview-sme.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    JssModule,
    UtilsModule,
    AutomationIdDirective,
    TrackLinkDirective,
    OfferOverviewChangeOfferComponent,
    OrderOverviewConsumptionComponent,
    OrderOverviewStickerComponent,
    OrderOverviewCostComponent,
    OrderOverviewBudgetBillComponent,
    ToolTipComponent,
    SvgSkeletonLoaderComponent,
  ],
})
export class OrderOverviewSmeComponent extends BaseOrderOverviewComponent {
  readonly fields = computed(() => this.rendering()?.fields);
  readonly yearlyCostLabel = computed(() =>
    getYearlyCostsLabel(
      ...getOrderOverviewFields(this.rendering()),
      this.offer()
    )
  );
  readonly getFieldValueBBAFeatureFlag = computed(() =>
    getFieldValue<boolean>(this.rendering(), 'EnableRemoveBBA')
  );
}
